module.exports = __webpack_public_path__ + "static/media/my_dream.884fc7e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/music/my_dream.mp3
// module id = gLAj
// module chunks = 2